import {
	useEmailFormController,
	USER_EMAIL_FORM,
} from '@dealstack/frontend/admin/pages/Manage/User/ManageUser/EmailForm/useEmailFormController';
import { StringInput } from '@dealstack/frontend/shared/components/forms/StringInput/StringInput';
import { SaveButton } from '@dealstack/frontend/shared/components/fundament/Button/CommonButtons';
import { DataUserTct } from '@dealstack/shared/lib/generated';
import { memo } from 'react';
import { FormProvider } from 'react-hook-form';
import styled from 'styled-components';

interface Props {
	user?: DataUserTct;
	refreshData: () => void;
}

const EmailForm = ({ user, refreshData }: Props) => {
	const {
		updateEmailForm,
		onEmailUpdateSubmit,
		isEligibilityLoading,
		isEmailChangeBlocked,
		isEmailFieldLocked,
		emailChangeExplanation,
	} = useEmailFormController(refreshData, user);

	const isFieldDisabled = isEligibilityLoading || isEmailFieldLocked;

	return (
		<div>
			<FormProvider {...updateEmailForm}>
				<Row>
					<StringInput
						label="Email"
						name={USER_EMAIL_FORM.EMAIL}
						disabled={isFieldDisabled}
					/>
					<SaveButton
						disabled={
							isFieldDisabled ||
							isEmailChangeBlocked ||
							!updateEmailForm.formState.isDirty
						}
						onClick={updateEmailForm.handleSubmit(onEmailUpdateSubmit)}
					/>
				</Row>
				{emailChangeExplanation ? (
					<Explanation data-testid="email-change-blocked-explanation">
						{emailChangeExplanation}
					</Explanation>
				) : null}
			</FormProvider>
		</div>
	);
};

const Row = styled.div`
	display: flex;
	align-items: end;
	grid-template-columns: 1fr 1fr;
	grid-gap: 1em;
`;
const Explanation = styled.p`
	margin: 0.5rem 0 0;
	max-width: 40rem;
	font-size: 0.75rem;
	color: ${({ theme }) => theme.v2.color.neutral[700]};
`;
const _EmailFormExport = memo(EmailForm);

export { _EmailFormExport as EmailForm };
